"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function fetchData(url, body, method = 'GET', headers = {}, defaultSuccessFunction = (res) => res, defaultErrorFunction = (err) => err) {
    const stringifyBody = body ? JSON.stringify(body) : undefined;
    return new Promise((resolve, reject) => {
        fetch(url, { method, headers, body: stringifyBody })
            .then((res) => res.json())
            .then((res) => defaultSuccessFunction(res))
            .then((res) => resolve(res))
            .catch((err) => defaultErrorFunction(err))
            .then((err) => reject(err));
    });
}
exports.default = fetchData;
//# sourceMappingURL=fetchData.js.map